import { TRANSACTION } from './adaptiveCardActionTypes';
import TransactionAction from '../cardActions/TransactionAction';
import { AdaptiveCard } from 'adaptivecards';

export default function registerActions() {
    AdaptiveCard.actionTypeRegistry.registerType(TRANSACTION, () => {
        return new TransactionAction();
    });
}
